export const featureData = {
    mainTitle: 'Why Choose HRD for Sealant Renewals?',
    items: [
        {
            number: '01',
            heading: 'Over 20 years of expertise in high-rise restoration and exterior maintenance.'
        },
        {
            number: '02',
            heading: 'Premium materials and industry-leading techniques for long-lasting results.'
        },
        {
            number: '03',
            heading: 'Minimal disruption to occupants and business operations.'
        },
        {
            number: '04',
            heading: 'Commitment to safety, compliance, and environmental responsibility.'
        }
    ],
    title: "Protect Your Building for Years to Come",
    subtitle:
        'Caulking and sealant renewal is a critical part of building maintenance, preventing costly damage and preserving your property’s longevity. Trust HRD Painting & Restoration to provide seamless, durable, and professional sealing solutions.',
    ctaText:
        'CONTACT US TODAY TO DISCUSS HOW WE CAN PROTECT AND ENHANCE YOUR PROPERTY!',
    backgroundImage: '/assets/imgs/services/2Caulking&SealantRenewal/featuregridSection/fondo.png'
};
